initShowMore();

function initShowMore()
{
    document.querySelectorAll('.hidden-more-show').forEach(item => {
        item.addEventListener('click', event =>
        {
            var parentElement = findParentWithClass(item, 'hidden-more-box');

            if (parentElement !== false)
            {
                parentElement.querySelectorAll('.hidden-more-item').forEach(item => {
                    item.classList.remove('hidden-more-item-hidden');
                });

                parentElement.querySelectorAll('.hidden-more-show').forEach(item => {
                    item.style.display = 'none';
                });
            }
        });
    });
}

// Najde parent element pro item, který má class parentClass
function findParentWithClass(item, parentClass)
{
    if (item.parentNode.classList.contains(parentClass))
    {
        return item.parentNode;
    }
    else if (item.tagName === 'body')
    {
        return false; // došli jsme už moc daleko
    }

    // Hledáme parenta parenta..
    return findParentWithClass(item.parentNode, parentClass);
}